import { EMPTY_FILTERS, hasDistrict, parsePostcodeList } from "@/lib/audienceEngine";
import { PRESET_BY_ID, representAsPresets, togglePresetFilters } from "@/data/presets";
import { SIGNAL_KEYS } from "@/data/mosaic";

export const WORKSPACE_PATH = "/audience";

const list = (v) => (v ? v.split(",").map((s) => s.trim()).filter(Boolean) : []);

export function readUrlState() {
  const p = new URLSearchParams(window.location.search);
  const areas = parsePostcodeList(p.get("areas") || "").filter(hasDistrict);
  let filters = { ...EMPTY_FILTERS };
  list(p.get("preset")).forEach((id) => {
    if (PRESET_BY_ID[id] && id !== "all") filters = togglePresetFilters(filters, PRESET_BY_ID[id]);
  });
  const stage = list(p.get("stage")).filter((s) => ["PRE", "RET"].includes(s));
  const beds = list(p.get("beds")).map(Number).filter((b) => [2, 3, 4, 5].includes(b));
  if (stage.length) filters.retirement = stage;
  if (beds.length) filters.property = beds;
  list(p.get("signals")).forEach((k) => SIGNAL_KEYS.includes(k) && (filters[k] = true));
  if (p.get("match") === "all") filters.opportunityMatch = "all";
  const view = ["results", "campaign"].includes(p.get("view")) ? p.get("view") : null;
  return { areas, filters, view };
}

export function buildQuery(areas, filters) {
  const p = new URLSearchParams();
  if (areas.length) p.set("areas", areas.join(","));
  const presets = representAsPresets(filters);
  if (presets && presets[0] !== "all") p.set("preset", presets.join(","));
  if (!presets) {
    if (filters.retirement.length) p.set("stage", filters.retirement.join(","));
    if (filters.property.length) p.set("beds", filters.property.join(","));
    const signals = SIGNAL_KEYS.filter((k) => filters[k] === true);
    if (signals.length) p.set("signals", signals.join(","));
  }
  if (filters.opportunityMatch === "all") p.set("match", "all");
  return p.toString().replace(/%2C/g, ",");
}

export function writeUrlState(areas, filters, view = "define", pushState = null) {
  const p = new URLSearchParams(buildQuery(areas, filters));
  if (view === "results" || view === "campaign") p.set("view", view);
  const qs = p.toString().replace(/%2C/g, ",");
  const url = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`;
  if (pushState) window.history.pushState(pushState, "", url);
  else window.history.replaceState(window.history.state, "", url);
}

export function workspaceUrl(areas, filters = EMPTY_FILTERS) {
  const qs = buildQuery(areas, filters);
  return `${WORKSPACE_PATH}${qs ? `?${qs}` : ""}`;
}

// The audience workspace opens in its own tab so the landing page stays clean.
export function openWorkspace(areas, filters) {
  const url = workspaceUrl(areas, filters);
  const win = window.open(url, "_blank");
  if (win) win.opener = null;
  else window.location.assign(url);
}
